<h2 mat-dialog-title i18n="hide header app tile header@@delete-header-apps-and-tools-dialog-confirm">Hide app</h2>
<mat-dialog-content>
    <span i18n="text app tile hide@@text-app-tile-hide">Are you sure you want to hide this app?</span>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="warn" class="mr-3 primary-contrast-color" (click)="hide()" i18n="hide app tile@@hide-app-tile">Hide</button>
    <button mat-button mat-flat-button class="subtle-button-color" mat-dialog-close i18n="cancel apps and tools dialog add edit@@cancel-apps-and-tools-dialog-add-edit">Cancel</button>
</mat-dialog-actions>
